import { createTicker } from "@/shared/lib/ticker";
import { useEffect, useState } from "react";

export const useTicker = ({
  onFrameUpdated,
}: {
  onFrameUpdated: (elapsed: number) => void;
}) => {
  const [ticker] = useState(() => createTicker());

  useEffect(() => {
    ticker.on("onFrameUpdated", onFrameUpdated);
    return () => {
      ticker.off("onFrameUpdated", onFrameUpdated);
    };
  }, []);

  return ticker;
};
